import httpClient from '@src/services/http.service'

export const state = {
  pageData: {},
  isEmptySearch: false,
  redirectValue: ''
}

export const actions = {
  init: ({ commit }) => {
    httpClient.get('pages/5fd771cc072e5479bded0f2b')
    .then(response => {
      commit('SET_PAGE_DATA', response.data)
    })
    .catch(error => {
      commit('SET_ERROR', error.message)
    })
  },
}

export const mutations = {
  SET_PAGE_DATA: (state, pageData) => {
    state.pageData = pageData
  },
  SET_BUTTON_EVENT: (state, data) => {
    state.isEmptySearch = data
  },
  SET_REDIRECT_VALUE: (state, data) => {
    state.redirectValue = data
  }
}

export const getters = {
  isEmptySearch: state => state.isEmptySearch,
  pageData: state => state.pageData,
  redirectValue: state => state.redirectValue
}

export default {
  state,
  getters,
  actions,
  mutations
}
